import { render, staticRenderFns } from "./BrandKitLogo.vue?vue&type=template&id=f0895988&scoped=true&"
import script from "./BrandKitLogo.vue?vue&type=script&lang=js&"
export * from "./BrandKitLogo.vue?vue&type=script&lang=js&"
import style0 from "./BrandKitLogo.vue?vue&type=style&index=0&id=f0895988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0895988",
  null
  
)

export default component.exports